module.exports = __webpack_public_path__ + "img/6.d8c2f292.svg";